"use client";

import React, { FC, PropsWithChildren, useContext } from "react";

import { BreadcrumbsList } from "@/app/_internal/getBreadcrumbsList/getBreadcrumbsList";

import { DEFAULT_PAGE_CONFIG_VALUE, PageConfig } from "./schema";

export type PageConfigContext = PageConfig & {
  breadcrumbsList: BreadcrumbsList;
  useHeadingTagForBreadcrumbs?: boolean;
  transparentHeaderTheme?: "light" | "dark" | "inherit";
};

const PageConfigContext = React.createContext<PageConfigContext>({
  ...DEFAULT_PAGE_CONFIG_VALUE,
  breadcrumbsList: [],
});

export const PageConfigProvider: FC<
  PropsWithChildren<{ value: PageConfigContext }>
> = ({ children, value }) => {
  return (
    <PageConfigContext.Provider value={value}>
      {children}
    </PageConfigContext.Provider>
  );
};

export const usePageConfig = (): PageConfigContext => {
  return useContext(PageConfigContext);
};
